// import React from "react";
// import "./Footer.css";
// import {
//   FaFacebookF,
//   FaLinkedinIn,
//   FaInstagram,
//   FaPhoneAlt,
// } from "react-icons/fa";
// import { MdEmail, MdLocationPin } from "react-icons/md";
// import logo3 from "../images/logo3.png";

// export default function Footer() {
//   return (
//     <footer className="ct-footer">
//       {/* top accent bar */}
//       <div className="ct-footer-accent" />

//       <div className="ct-footer-inner">
//         <div className="ct-footer-grid">
//           {/* Brand */}
//           <div className="ct-footer-col ct-footer-brand">
//             <div className="ct-footer-logo">
//               <div className="ct-footer-logo-icon">
//                 <img src={logo3} alt="Logo" className="ct-logo-image" />
//               </div>
//               <h2 className="ct-footer-logo-text">Aazira Solutions</h2>
//             </div>
//             <p className="ct-footer-about">
//               We build future-ready digital solutions using modern technologies,
//               delivering scalable software, AI, mobile apps, and cloud products
//               for ambitious businesses.
//             </p>
//           </div>

//           {/* Quick Links */}
//           <div className="ct-footer-col">
//             <h3 className="ct-footer-title">Quick Links</h3>
//             <ul className="ct-footer-links">
//               <li className="ct-footer-links-item">
//                 <a href="/">Home</a>
//               </li>
//               <br />
//               <li className="ct-footer-links-item">
//                 <a href="/about">About</a>
//               </li>
//               <br />
//               <li className="ct-footer-links-item">
//                 <a href="/service">Services</a>
//               </li>
//               <br />

//               <li className="ct-footer-links-item">
//                 <a href="/products">Products</a>
//               </li>
//               <br />

//               <li className="ct-footer-links-item">
//                 <a href="/careers">Careers</a>
//               </li>
//               <br />

//               <li className="ct-footer-links-item">
//                 <a href="/contact">Contact</a>
//               </li>
//             </ul>
//           </div>

//           {/* Services */}
//           {/* <div className="ct-footer-col">
//             <h3 className="ct-footer-title">Services</h3>
//             <ul className="ct-footer-links">
//               <li className="ct-footer-links-item">Custom Software</li>
//               <li className="ct-footer-links-item">
//                 AI &amp; Machine Learning
//               </li>
//               <li className="ct-footer-links-item">Mobile App Development</li>
//               <br/>
//               <li className="ct-footer-links-item">Cloud &amp; DevOps</li>
//               <br/>
//               <li className="ct-footer-links-item">UI/UX Design</li>
//             </ul>
//           </div> */}
//           <div className="ct-footer-col">
//             <h3 className="ct-footer-title">Services</h3>
//             <ul className="ct-footer-links">
//               <li className="ct-footer-links-item">
//                 <a href="/SoftwareDevelopment" className="footer-service-link">
//                   Custom Software
//                 </a>
//               </li>

//               <li className="ct-footer-links-item">
//                 <a href="/AIIntegration" className="footer-service-link">
//                   AI &amp; Machine Learning
//                 </a>
//               </li>

//               <li className="ct-footer-links-item">
//                 <a href="/SoftwareDevelopment" className="footer-service-link">
//                   Mobile App Development
//                 </a>
//               </li>

//               <li className="ct-footer-links-item">
//                 <a href="/CloudServices" className="footer-service-link">
//                   Cloud &amp; DevOps
//                 </a>
//               </li>
//               <br />
//               <li className="ct-footer-links-item">
//                 <a href="/DigitalMarketing" className="footer-service-link">
//                   Digital Marketing
//                 </a>
//               </li>
//               <li className="ct-footer-links-item">
//                 <a href="/SoftwareDevelopment" className="footer-service-link">
//                   Websites Development
//                 </a>
//               </li>
//             </ul>
//           </div>

//           {/* Contact */}
//           <div className="ct-footer-col ct-footer-contact-col">
//             <h3 className="ct-footer-title">Contact Info</h3>
//             <ul className="ct-footer-contact">
//               {/* <li className="ct-footer-contact-item">
//                 <MdLocationPin className="ct-footer-icon" />
//                 <span>
//                   Head Office: Office no. 213-214,Second Floor, City Point, Boat
//                   Club Rd, Bund Garden, Sangamvadi, Pune, Maharashtra 411001
//                 </span>
//               </li> */}
//               <li className="ct-footer-contact-item">
//                 <MdLocationPin className="ct-footer-icon" />
//                 <a
//                   href="https://www.google.com/maps/search/?api=1&query=City+Point+Boat+Club+Road+Bund+Garden+Sangamvadi+Pune+Maharashtra+411001"
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="ct-footer-clickable"
//                   style={{ color: "inherit", textDecoration: "none" }}
//                 >
//                   Head Office: Office no. 213-214, Second Floor, City Point,
//                   Boat Club Rd, Bund Garden, Sangamvadi, Pune, Maharashtra
//                   411001
//                 </a>
//               </li>

//               {/* PHONE CLICK → OPENS DIALER */}
//               <li className="ct-footer-contact-item">
//                 <FaPhoneAlt className="ct-footer-icon" />
//                 <a
//                   href="tel:+918983971671"
//                   className="ct-footer-clickable"
//                   style={{ color: "inherit", textDecoration: "none" }}
//                 >
//                   +91 7276445893
//                 </a>
//               </li>

//               {/* EMAIL CLICK → OPENS EMAIL APP */}
//               <li className="ct-footer-contact-item">
//                 <MdEmail className="ct-footer-icon" />
//                 <a
//                   href="mailto:info@aazirasolutions.com"
//                   className="ct-footer-clickable"
//                   style={{ color: "inherit", textDecoration: "none" }}
//                 >
//                   info@aazirasolutions.com
//                 </a>
//               </li>
//             </ul>

//             <div className="ct-footer-socials">
//               <a
//                 href="https://www.facebook.com/share/15SJtaLeNL6/?mibextid=wwXIfr"
//                 className="ct-footer-social-link"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaFacebookF />
//               </a>

//               <a
//                 href="https://www.linkedin.com/company/cordontechnologiespvtltd/"
//                 className="ct-footer-social-link"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaLinkedinIn />
//               </a>

//               <a
//                 href="https://www.instagram.com/cordon_technologies?utm_source=qr"
//                 className="ct-footer-social-link"
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 <FaInstagram />
//               </a>
//               <a
//                 href="https://www.google.com/maps/dir/?api=1&destination=City+Point+Boat+Club+Road+Bund+Garden+Sangamvadi+Pune+Maharashtra+411001"
//                 target="_blank"
//                 rel="noopener noreferrer"
//                 className="ct-footer-social-link"
//                 style={{
//                   marginLeft: "8px",
//                   color: "#279EFF",
//                   fontSize: "20px",
//                 }}
//               >
//                 <MdLocationPin />
//               </a>
//             </div>
//           </div>
//         </div>

//         <div className="ct-footer-divider" />

//         <div className="ct-footer-bottom">
//           <p>
//             © {new Date().getFullYear()} Aazira Solutions. All Rights
//             Reserved.
//           </p>
//         </div>
//       </div>
//     </footer>
//   );
// }

import React from "react";
import "./Footer.css";
import { FaFacebookF, FaLinkedinIn, FaInstagram } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { MdEmail, MdLocationPin } from "react-icons/md";
// import logo3 from "../images/logo3.png";
import logo4 from "../images/logo4.png"
export default function Footer() {
  return (
    <footer className="ct-footer">
      {/* top accent bar */}
      <div className="ct-footer-accent" />

      <div className="ct-footer-inner">
        <div className="ct-footer-grid">
          {/* Brand */}
          <div className="ct-footer-col ct-footer-brand">
            <div className="ct-footer-logo">
              <div className="ct-footer-logo-icon">
                <img src={logo4} alt="Logo" className="ct-logo-image" />
              </div>
              <h2 className="ct-footer-logo-text">Aazira Solutions</h2>
            </div>
            <p className="ct-footer-about">
              We build future-ready digital solutions using modern technologies,
              delivering scalable software, AI, mobile apps, and cloud products
              for ambitious businesses.
            </p>
          </div>

          {/* Quick Links */}
          <div className="ct-footer-col">
            <h3 className="ct-footer-title">Quick Links</h3>
            <ul className="ct-footer-links">
              <li className="ct-footer-links-item"><a href="/">Home</a></li>
              <br/>
              <li className="ct-footer-links-item"><a href="/about">About</a></li>
              <br/>              
              <li className="ct-footer-links-item"><a href="/service">Services</a></li>
              <br/>
              <li className="ct-footer-links-item"><a href="/products">Products</a></li>
              <br/>
              <li className="ct-footer-links-item"><a href="/careers">Careers</a></li>
              <br/>
              <li className="ct-footer-links-item"><a href="/contact">Contact</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="ct-footer-col">
            <h3 className="ct-footer-title">Services</h3>
            <ul className="ct-footer-links">
              <li className="ct-footer-links-item"><a href="/SoftwareDevelopment" className="footer-service-link">Custom Software</a></li>
              <li className="ct-footer-links-item"><a href="/AIIntegration" className="footer-service-link">AI & Machine Learning</a></li>
              <li className="ct-footer-links-item"><a href="/MobileAppDevelopment" className="footer-service-link">Mobile App Development</a></li>
              <li className="ct-footer-links-item"><a href="/CloudServices" className="footer-service-link">Cloud & DevOps</a></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="ct-footer-col ct-footer-contact-col">
            <h3 className="ct-footer-title">Contact Info</h3>
            <ul className="ct-footer-contact">
              <li className="ct-footer-contact-item">
                <MdLocationPin className="ct-footer-icon" />
                <a href="https://www.google.com/maps" target="_blank" rel="noopener noreferrer">
                  Head Office: Office no. 213-214, City Point, Boat Club Rd, Pune, Maharashtra 411001
                </a>
              </li>
              <li className="ct-footer-contact-item">
                <FaPhoneAlt className="ct-footer-icon" />
                <a href="tel:+917276445893">+91 7276445893</a>
              </li>
               <li className="ct-footer-contact-item">
                <FaPhoneAlt className="ct-footer-icon" />
              <a href="tel:+918983971671">+91 8983971671</a>
              </li>
              <li className="ct-footer-contact-item">
                <MdEmail className="ct-footer-icon" />
                <a href="mailto:info@aazirasolutions.com">
                  info@aazirasolutions.com
                </a>
              </li>
            </ul>
            <div className="ct-footer-socials">
              {/* Social Media Icons with Official Colors */}
              <a href="https://www.facebook.com/share/1FnYA9Ds11/?mibextid=wwXIfr" className="ct-footer-social-link" target="_blank" rel="noopener noreferrer">
                <FaFacebookF style={{ color: '#1877f2' }} />
              </a>
              <a href="https://www.linkedin.com/company/aaziratechnologiespvtltd" className="ct-footer-social-link" target="_blank" rel="noopener noreferrer">
                <FaLinkedinIn style={{ color: '#0a66c2' }} />
              </a>
              <a href="https://www.instagram.com/aazira_solutions?igsh=MTY4ajQ3anNocDB5NQ%3D%3D&utm_source=qr" className="ct-footer-social-link" target="_blank" rel="noopener noreferrer">
                <FaInstagram style={{ color: '#e1306c' }} />
              </a>
            </div>
          </div>
        </div>

        <div className="ct-footer-divider" />

        <div className="ct-footer-bottom">
          <p>© {new Date().getFullYear()} Aazira Solutions. All Rights Reserved.</p>
        </div>
      </div>
    </footer>
  );
}
